import { render, staticRenderFns } from "./userInCourse.vue?vue&type=template&id=118c169b"
import script from "./userInCourse.vue?vue&type=script&lang=js"
export * from "./userInCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports